import { SquareRounded } from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  TextField,
} from "@mui/material";
import boxIcon from "assets/box.svg";
import CustomLink from "components/CustomLink";
import CustomText from "components/typography/CustomText";
import { useSnackbar } from "notistack";

const voucherOptions = Array.from(Array(12).keys()).map((item, index) => ({
  label: `${index + 1} x Pie Club Boxes`,
  id: index + 1,
}));

export default function DeliveriesForm({
  data = {},
  onChange = () => {},
  onNext = () => {},
}) {
  const { enqueueSnackbar } = useSnackbar();
  const handleChange = (e, v) => {
    onChange({ target: { name: "box_count", value: v } });
  };

  const handleCheck = (e) => {
    onChange({
      target: { name: e.target.name, value: Boolean(e?.target?.checked) },
    });
  };

  const handleClickNext = () => {
    if (!Boolean(data?.box_count?.id))
      return enqueueSnackbar("Boxes are required", { variant: "warning" });
    if (!Boolean(data?.terms_condition))
      return enqueueSnackbar("Please check terms & conditions!", {
        variant: "warning",
      });
    onNext();
  };

  return (
    <div className="bg-secondary px-14 py-24 w-voucher-box rounded-3xl">
      <CustomText className="font-zing text-white text-3xl">
        SELECT NUMBER OF BOX DELIVERIES:
      </CustomText>
      <Autocomplete
        fullWidth
        className="py-4"
        name="box_count"
        value={data?.box_count || null}
        options={voucherOptions}
        getOptionLabel={(option) => option.label}
        onChange={handleChange}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder="Click to select"
              fullWidth
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <>
                    <InputAdornment position="start">
                      <img src={boxIcon} alt="box icon" />
                    </InputAdornment>
                    {params.InputProps.startAdornment}
                  </>
                ),
              }}
            />
          );
        }}
      />
      <CustomText className="text-white text-base">
        Each Box Delivery Contains 8 Glorious Fat Bastard Pies
      </CustomText>
      <CustomText className="text-white text-base italic">
        Includes Shipping
      </CustomText>
      <CustomText className="pt-10 pb-2 text-white uppercase text-voucher font-zing">
        voucher total:{" "}
        {data?.box_count?.id
          ? `$${data?.box_count?.id === 1 ? 73 : data?.box_count?.id * 65}`
          : ""}
      </CustomText>
      <div className="py-3">
        <FormControlLabel
          className="flex items-center"
          control={
            <Checkbox
              color="primary"
              size="large"
              name="terms_condition"
              checked={data?.terms_condition ?? false}
              onChange={handleCheck}
              icon={
                <SquareRounded
                  sx={{ fill: "#fff" }}
                  color="white"
                  fontSize="large"
                />
              }
            />
          }
          label={
            <CustomText className="text-white text-base flex">
              Accept our
              <CustomLink
                className="text-base underline pl-1 italic"
                target="_blank"
                to="https://www.fatbastardpies.nz/terms"
              >
                {" "}
                TERMS & CONDITIONS
              </CustomLink>
            </CustomText>
          }
        />
      </div>
      <Button
        className="uppercase px-6 text-2xl font-zing"
        variant="contained"
        onClick={handleClickNext}
      >
        next
      </Button>
    </div>
  );
}
